import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateData,
  formData,
  getList,
  updateList,
  setFormData,
  id,
  history,
  showData,
}) {
  const rules = {
    name: 'required',
  };

  const validateForm = useFormValidator(formData, rules);

  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
    };
    updateData(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getList();
      showData(id);
      history.push(
        `/rpt/machinery/machinery-settings/list-of-machinery/${_.get(
          data,
          'id'
        )}`
      );
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  useEffect(() => {
    validateForm.onSetObjectRules(rules);
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="name" className="form-label mb-0">
              Name &nbsp; {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="description" className="form-label mb-0">
              Description
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="brand_model" className="form-label mb-0">
              Brand / Model
            </label>
            <input
              className="form-control"
              type="text"
              name="brand_model"
              onChange={onChange}
              value={_.get(formData, 'brand_model') || ''}
              placeholder="Enter Brand / Model"
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="capacity" className="form-label mb-0">
              Capacity / HP
            </label>
            <input
              className="form-control"
              type="text"
              name="capacity"
              onChange={onChange}
              value={_.get(formData, 'capacity') || ''}
              placeholder="Enter Capacity / HP"
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-2"
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
            disabled={!validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
